module.exports = __webpack_public_path__ + "static/media/wellnite-auth-hero_200.c722682e.png";